import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Radio, Form, Input, message, Button, Upload, Modal, Slider } from "antd";
import Cropper from "react-easy-crop";
import { UploadOutlined, CloseOutlined } from "@ant-design/icons";
import axios from "../../helper/axios";
import editIcon from "../../assets/pencil.png";
import useJDStore from "../../store/jd.store";
import memberstore from "../../store/members.store";

import "./profile.scss";
import TextArea from "antd/es/input/TextArea";


export default function Profile() {
  const [isEditMode, setIsEditMode] = useState(false);
  const [formKey, setFormKey] = useState(1);
  const { value } = useParams();
  const { selectedJD } = useJDStore();
  const { updateUserInfo } = memberstore();
  const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};
  const [logoFile, setLogoFile] = useState(null);
  const getImageSrc = (img) => {
    if (!img) return null;
    if (typeof img !== "string") return img;
    if (img.startsWith("data:")) return img;

    const sig = img.slice(0, 5);
    if (sig.startsWith("/9j/")) return `data:image/jpeg;base64,${img}`;
    if (sig.startsWith("iVBOR")) return `data:image/png;base64,${img}`;
    if (sig.startsWith("R0lG")) return `data:image/gif;base64,${img}`;

    return `data:image/jpeg;base64,${img}`;
  };
  const [logoPreview, setLogoPreview] = useState(
    getImageSrc(userDetails?.company_logo) || null,
  );
  const [cropSource, setCropSource] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [isCropModalOpen, setIsCropModalOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {}, []);

  const createImage = (source) =>
    new Promise((resolve, reject) => {
      const image = new Image();
      image.addEventListener("load", () => resolve(image));
      image.addEventListener("error", reject);
      image.src = source;
    });

  const getCroppedImage = async (source, cropPixels, fileName, fileType) => {
    const image = await createImage(source);
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    canvas.width = cropPixels.width;
    canvas.height = cropPixels.height;
    context.drawImage(
      image,
      cropPixels.x,
      cropPixels.y,
      cropPixels.width,
      cropPixels.height,
      0,
      0,
      cropPixels.width,
      cropPixels.height,
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error("Unable to crop image"));
          return;
        }
        resolve(new File([blob], fileName, { type: fileType || "image/jpeg" }));
      }, fileType || "image/jpeg");
    });
  };

  const getUploadedFileFromValue = (value) => {
    if (!value) return null;
    if (value instanceof File) return value;
    if (value?.originFileObj instanceof File) return value.originFileObj;
    if (
      Array.isArray(value?.fileList) &&
      value.fileList[0]?.originFileObj instanceof File
    ) {
      return value.fileList[0].originFileObj;
    }
    if (Array.isArray(value) && value[0]?.originFileObj instanceof File) {
      return value[0].originFileObj;
    }
    return null;
  };

  const buildProfileFormData = (values) => {
    const formData = new FormData();

    Object.entries(values).forEach(([key, val]) => {
      if (val === undefined || val === null) return;

      if (key === "companyLogo") {
        const uploadedFile = logoFile || getUploadedFileFromValue(val);
        if (uploadedFile) {
          formData.append("companyLogo", uploadedFile, uploadedFile.name);
        }
        return;
      }

      if (
        typeof val === "object" &&
        !(val instanceof File) &&
        !(val instanceof Blob)
      ) {
          formData.append(key, JSON.stringify(val));
        
      } else {
        if(key == "permission"){
          formData.append(key, val?.toLowerCase());
        }else{
          formData.append(key, val);
        }        
        
      }
    });

    if (logoFile && !values?.companyLogo) {
      formData.append("companyLogo", logoFile, logoFile.name);
    }

    //console.log("built formdata entries", [...formData.entries()]);
    return formData;
  };

  const submitProfile = async (values, endpoint, method = "post") => {
    console.log(values);

    const formData = buildProfileFormData(values);
    console.log("formdata", formData);

  };

  const handleFormSubmit = async (values) => {
    try {
      const formData = buildProfileFormData(values);

      // TODO: replace with your actual backend route
      await updateUserInfo(userDetails.qhoid, formData);
      message.success("Profile updated successfully");
      setIsEditMode(false);      
    } catch (error) {
      // error message is already shown in submitProfile
    }
  };

  const handleLogoBeforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("You can only upload image files!");
      return Upload.LIST_IGNORE;
    }

    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must be smaller than 2MB!");
      return Upload.LIST_IGNORE;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      setCropSource(e.target.result);
      setCrop({ x: 0, y: 0 });
      setZoom(1);
      setIsCropModalOpen(true);
    };
    reader.readAsDataURL(file);
    return false;
  };

  const handleCropComplete = (_, cropPixels) => {
    setCroppedAreaPixels(cropPixels);
  };

  const handleCropCancel = () => {
    setCropSource(null);
    setIsCropModalOpen(false);
    setZoom(1);
  };

  const handleCropApply = async () => {
    if (!cropSource || !croppedAreaPixels) return;

    try {
      const croppedFile = await getCroppedImage(
        cropSource,
        croppedAreaPixels,
        "company-logo.jpg",
        "image/jpeg",
      );
      const previewReader = new FileReader();
      previewReader.onload = (e) => setLogoPreview(e.target.result);
      previewReader.readAsDataURL(croppedFile);
      setLogoFile(croppedFile);
      setCropSource(null);
      setIsCropModalOpen(false);
    } catch (error) {
      message.error("Unable to crop image. Please try again.");
    }
  };

  const handleLogoRemove = () => {
    setLogoFile(null);
    setLogoPreview(getImageSrc(userDetails?.company_logo) || null);
    handleCropCancel();
  };

  const handleCancelEdit = () => {
    setLogoFile(null);
    setLogoPreview(getImageSrc(userDetails?.company_logo) || null);
    handleCropCancel();
    setIsEditMode(false);
  };

  const handleUpdateFormSubmit = async (values) => {
    try {
      const endpoint = "/profile/update"; // TODO: replace with your actual backend route
      await submitProfile(values, endpoint, "post");
      setIsEditMode(false);
      message.success("Profile updated successfully");
    } catch (error) {
      // error message is already shown in submitProfile
    }
  };

    useEffect(() => {
        setFormKey((prevKey) => prevKey + 1);
    }, [selectedJD]);

    var profileValues = {
            user_name: userDetails?.username,
            permission: userDetails?.permission?.toUpperCase(),
            organization: userDetails?.organization,
            organization_type: userDetails?.account_type,
            website:userDetails?.weburl,
            orgstrength:userDetails?.orgstrength,
            mobile: userDetails?.contact,
            email: userDetails?.email,
            city: userDetails?.city,
            country: userDetails?.country,
            pincode:userDetails?.pincode,
            sub_status: userDetails?.sub_status,
            sub_name: userDetails?.sub_name,
            sub_type: userDetails?.sub_type,
            sub_date: userDetails?.offered_CTC,
            sub_start_date: userDetails?.creation_date,
            sub_end_date: userDetails?.priority,
            creation_date: userDetails?.creationdate,
            address : userDetails?.address,
            headquarters : userDetails?.headquarters,
            industrytype : userDetails?.industrytype,
            organization_details : userDetails?.organization_details,
    }

    return (
        <div className="profile-form-wrapper">
            <div className="header">
                {!isEditMode ? (
                    <Button className="profile-edit-button" onClick={() => setIsEditMode(true)} type="primary">
                        <img
                            src={editIcon}
                            alt="Edit"
                            width="14" height="14" 
                        />
                    </Button>
                ) : (
                    <Button className="profile-edit-button" onClick={handleCancelEdit}>
                        <CloseOutlined /> Cancel
                    </Button>
                )}
            </div>
            <Form
                key={formKey}
                className="profile-form"
                name="profile-form"
                justify="start"
                layout="vertical"
                autoComplete="off"
                onFinish={value ? handleUpdateFormSubmit : handleFormSubmit}
                initialValues={profileValues}
            >
        <div className="company-logo-wrapper">
          <Form.Item
            className="profile-field-item"
            label=""
            name="companyLogo"
            valuePropName="fileList"
            getValueFromEvent={(e) => {
              if (Array.isArray(e)) return e;
              return e?.fileList || [];
            }}
          >
            <Upload
              accept="image/*"
              beforeUpload={handleLogoBeforeUpload}
              onRemove={handleLogoRemove}
              showUploadList={false}
              disabled={!isEditMode}
              multiple={false}
            >
              <div className="profile-logo-upload">
                {logoPreview ? (
                  <img
                    src={logoPreview}
                    alt="Company Logo"
                    className="company-logo-preview"
                  />
                ) : (
                  <div className="upload-placeholder">
                    {isEditMode
                      ? "Click to upload logo"
                      : "No company logo uploaded"}
                  </div>
                )}
                {isEditMode && (
                  <Button icon={<UploadOutlined />} style={{ marginTop: 8 }}>
                    {logoPreview ? "Change Logo" : "Upload Logo"}
                  </Button>
                )}
              </div>
            </Upload>
          </Form.Item>
        </div>
                <div className="triple-input-wrapper">
                    <Form.Item
                        required={isEditMode}
                        className="profile-field-item"
                        label="User Name"
                        name="user_name"
                    >
                        <Input
                            disabled={!isEditMode}
                            required={isEditMode}
                            className="profile-input"
                        />
                    </Form.Item>
                    <Form.Item
                        className="profile-field-item"
                        label="Permission"
                        name="permission"
                    >
                        <Input
                            disabled={true}
                            className="profile-input"
                        />
                    </Form.Item>   
                    <Form.Item
                            name="creation_date"
                            className="profile-field-item"
                            label="Profile Creation Date"
                        >
                            <Input
                                disabled={true}
                                className="profile-input"
                            />
                    </Form.Item>                                      
                </div>
                <div className="triple-input-wrapper">
                    <Form.Item
                        required={isEditMode}
                        className="profile-field-item"
                        label="Mobile Number"
                        name="mobile"
                    >
                        <Input
                            disabled={!isEditMode}
                            required={isEditMode}
                            className="profile-input"
                        />
                    </Form.Item>
                    <Form.Item                            
                            name="email"
                            className="profile-field-item"
                            label="Email ID"
                        >
                            <Input
                                disabled={true}                                
                                className="profile-input"
                            />
                    </Form.Item>
                    <Form.Item
                        className="profile-field-item"
                        label="Registered Office City"
                        name="city"
                    >
                        <Input
                            disabled={true}
                            className="profile-input"
                        />
                    </Form.Item>                    
                </div>
                {
                   
                    userDetails.permission === "superuser" || userDetails.permission ==="superadmin"?
                    <>
                        <div className="triple-input-wrapper">
                            <Form.Item
                                    required={isEditMode}
                                    name="organization"
                                    className="profile-field-item"
                                    label="Organization Name"
                                >
                                    <Input
                                        disabled={!isEditMode}
                                        required={isEditMode}
                                        className="profile-input"
                                    />
                            </Form.Item> 
                            <Form.Item
                                    required={isEditMode}
                                    name="website"
                                    className="profile-field-item"
                                    label="Website"
                                >
                                    <Input
                                        disabled={!isEditMode}
                                        required={isEditMode}
                                        className="profile-input"
                                    />
                            </Form.Item>
                            <Form.Item
                                    required={isEditMode}
                                    name="orgstrength"
                                    className="profile-field-item"
                                    label="Organization Strength (Number of Employees)"
                                >
                                    <Input
                                        disabled={!isEditMode}
                                        required={isEditMode}
                                        className="profile-input"
                                        placeholder="100-200"
                                    />
                            </Form.Item>
                        </div>

                        <Form.Item
                            className="profile-field-item"
                            name="organization_type"
                            label="Select what describes you Best"
                        >
                            <Radio.Group
                                disabled={true}
                                className="profile-radio-wrapper"
                                onClick
                            >
                                <Radio
                                    className="radio-option"
                                    value="ProductOrg"
                                >
                                    Product Company
                                </Radio>
                                <Radio
                                    className="radio-option"
                                    value="ServiceOrg"
                                >
                                    Services Company
                                </Radio>

                                <Radio
                                    className="radio-option"
                                    value="StaffingOrg"
                                >
                                    Staffing/Recruitment Company
                                </Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            className="profile-field-item"
                            name="organization_details"
                            label="Brief Description of Organization"
                        >
                            <TextArea
                              required={true}
                              className="profile-field-item"
                            />
                        </Form.Item>
                        <Form.Item
                            className="profile-field-item"
                            name="organization_details"
                            label="Nujobs Page"
                        >
                        {"https://nujobs.quallyhireai.com/nujobswhoishiringnowcompany/company/"+userDetails?.qhoid}
                        </Form.Item> 

                        <div className="triple-input-wrapper">
                            <Form.Item
                                    required={isEditMode}
                                    name="industrytype"
                                    className="profile-field-item"
                                    label="Industry"
                                >
                                    <Input
                                        disabled={!isEditMode}
                                        required={isEditMode}
                                        className="profile-input"
                                    />
                            </Form.Item>                    

                            <Form.Item
                                    name="countrtypresence"
                                    className="profile-field-item"
                                    label="Country"
                                >
                                    <Input     
                                        disabled={true}
                                        placeholder="India"             
                                        className="profile-input"
                                    />
                            </Form.Item>
                            <Form.Item
                                    required={isEditMode}
                                    name="headquarters"
                                    className="profile-field-item"
                                    label="Headquarters"
                                >
                                    <Input                                
                                        disabled={!isEditMode}
                                        required={isEditMode}
                                        className="profile-input"
                                    />
                            </Form.Item>
                        </div>                                              
                        <div className="triple-input-wrapper">
                            <Form.Item
                                    required={isEditMode}
                                    name="address"
                                    className="profile-field-item"
                                    label="Registered Address"
                                >
                                    <Input
                                        disabled={!isEditMode}
                                        required={isEditMode}
                                        className="profile-input"
                                    />
                            </Form.Item>                    

                            <Form.Item
                                    name="country"
                                    className="profile-field-item"
                                    label="Country"
                                >
                                    <Input     
                                        disabled={true}             
                                        className="profile-input"
                                    />
                            </Form.Item>
                            <Form.Item
                                    required={isEditMode}
                                    name="pincode"
                                    className="profile-field-item"
                                    label="Pin Code"
                                >
                                    <Input                                
                                        disabled={!isEditMode}
                                        required={isEditMode}
                                        className="profile-input"
                                    />
                            </Form.Item>
                        </div>                          
                 
                    </>
                    :<></>
                }

                {
                    userDetails.permission === "superuser" || userDetails.permission ==="superadmin"
                    || userDetails.permission === "admin" ?  
                    <>
                        <Button
                            style={{ width: "50%", height: "40px", fontWeight: "600" }}
                            type="primary"
                            disabled={!isEditMode || submitting}
                            loading={submitting}
                            htmlType="submit"
                        >
                            Update Profile
                        </Button>                    
                    </>
                    :<>
                    </>
                }                
            </Form>
            <Modal
              open={isCropModalOpen}
              title="Adjust company logo"
              onCancel={handleCropCancel}
              footer={[
                <Button key="cancel" onClick={handleCropCancel}>
                  Cancel
                </Button>,
                <Button key="apply" type="primary" onClick={handleCropApply}>
                  Apply crop
                </Button>,
              ]}
              centered
            >
              <div className="profile-image-cropper">
                <Cropper
                  image={cropSource}
                  crop={crop}
                  zoom={zoom}
                  aspect={1}
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onCropComplete={handleCropComplete}
                  cropShape="round"
                  showGrid={false}
                />
              </div>
              <div className="profile-image-zoom-control">
                <span>Zoom</span>
                <Slider
                  min={1}
                  max={3}
                  step={0.1}
                  value={zoom}
                  onChange={setZoom}
                />
              </div>
            </Modal>
        </div>
    );
}
